// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2v223","productName":"Table_productName__2Es3i"};